import type { LiteralValues } from '@/utils/typing/literal-values.type';

export const Language = {
    FR: 'fr',
    EN: 'en',
    IT: 'it',
    DE: 'de'
} as const;
export type Language = LiteralValues<typeof Language>;

export const defaultLanguage = Language.FR;
